// Apenas para testar se o build funciona
import './index.scss';
import './frontend';


console.log('WPMundi Swatches carregado com sucesso via wp-scripts!');